'use strict';exports.__esModule = true;var _PropertyCell = require('../../components/PropertyCell/PropertyCell.scss');var styles = _interopRequireWildcard(_PropertyCell);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

var getButtonsConfig = function getButtonsConfig(data, handlers) {var

  isActive =

















  data.isActive,promoted = data.promoted,autoJumpEnabled = data.autoJumpEnabled,isTopPromotedProperty = data.isTopPromotedProperty,suspended = data.suspended,editButtonText = data.editButtonText,openDetailsButtonText = data.openDetailsButtonText,upgradePackageButtonText = data.upgradePackageButtonText,activeButtonText = data.activeButtonText,inactiveButtonText = data.inactiveButtonText,makeActiveText = data.makeActiveText,makeInactiveText = data.makeInactiveText,jumpToTopText = data.jumpToTopText,canMoveToTop = data.canMoveToTop,shareButtonText = data.shareButtonText,movePropertyToTop = data.movePropertyToTop,addressData = data.addressData,id = data.id;

  var activeInactiveTitle = void 0;
  var activeInactiveText = void 0;
  var activeInactiveIcon = void 0;

  if (isActive) {
    activeInactiveTitle = makeInactiveText;
    activeInactiveText = inactiveButtonText;
    activeInactiveIcon = 'active';
  } else {
    activeInactiveTitle = makeActiveText;
    activeInactiveText = activeButtonText;
    activeInactiveIcon = 'inactive';
  }
  var moveToTop = function moveToTop() {return movePropertyToTop(id);};
  var isForeign = (0, _checkIsForeignAddress2.default)(addressData);

  return {
    share: {
      props: {
        onClick: handlers.handleShare,
        disabled: !isActive || suspended },

      icon: 'share',
      title: shareButtonText },

    edit: {
      props: {
        onClick: handlers.handleEdit },

      icon: 'edit',
      title: editButtonText },

    jumpToTop: {
      props: {
        className: 'btnToTop',
        onClick: moveToTop,
        disabled: !isActive || !canMoveToTop },

      icon: 'jump-to-top' + (!isActive || !canMoveToTop ? '-disabled' : ''),
      title: jumpToTopText },

    secondJumpToTop: {
      props: {
        className: styles.secondJump,
        onClick: handlers.handleSecondJump,
        disabled: !isActive || suspended },

      icon: 'second-jump-to-top',
      title: '' },

    preview: {
      props: {
        onClick: handlers.openDetailsPopup },

      icon: 'preview',
      title: openDetailsButtonText },

    activity: {
      props: {
        onClick: handlers.toggleActivity,
        title: activeInactiveTitle,
        className: 'activityButton' },

      icon: isActive ? 'icon icon-inactive' : 'icon icon-active',
      title: activeInactiveText },

    upgradePackage: {
      props: {
        className: styles.upgradePackage,
        onClick: handlers.upgradePackage,
        title: 'upgradePackage',
        disabled: !isActive || suspended || promoted || autoJumpEnabled || isTopPromotedProperty || isForeign },

      icon: 'package-icon',
      title: upgradePackageButtonText } };


};exports.default =

getButtonsConfig;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ManagePropertiesPage/controlButtonsConfig.js
// module id = 1266
// module chunks = 0